module.exports = __webpack_public_path__ + "07bbed275ec28092130c015c3e82690b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/fake-horse-s.png
// module id = 1834
// module chunks = 0